import { useQuery } from '@tanstack/react-query'
import { getUser, fetchDevices } from './_auth'
import { identify } from '../../utils/analytics'
import { CustomCognitoUser } from './_types'

export const useAuthDataState = () => {
  return useQuery({
    queryKey: ['auth'],
    queryFn: getUser,
    onSuccess: (data: CustomCognitoUser) => {
      identify(data.attributes?.sub, data.attributes)
    },
    refetchOnWindowFocus: false,
    staleTime: 30000,
    retry: false,
  })
}

export const useAuthDevicesState = () => {
  return useQuery({
    queryKey: ['devices'],
    queryFn: fetchDevices,
    refetchOnWindowFocus: true,
    staleTime: 30000,
    retry: false,
  })
}
